// @flow
import React, { Component } from "react";
import { matchPath } from "react-router";
import { withRouter } from "react-router-dom";
import { setUserConfig, saveUserConfig } from "../../../actions";
import ConfigContainer from "../../../components/ConfigContainer";
import { connect } from "react-redux";
import FontIcon from "react-toolbox/lib/font_icon/FontIcon";
import { Tab, Tabs } from "react-toolbox";
import * as strings from "../../../strings";

import styles from "./styles.css";
import { IconMenu, Menu, MenuItem } from "react-toolbox/lib/menu";
import Button from "react-toolbox/lib/button";

class TopMenu extends Component {
  props: {
    tabs: [any],
    showConfig: boolean,
    processTab: [any],

    history: any,
    location: any,
    user: {
      id: number,
      config: [],
    },
    setUserConfig: (c: any) => {},
    saveUserConfig: () => {},
  };

  state = {
    configExpanded: false,
    index: 0,
    preLitActive: false,
    litActive: false,
  };

  componentWillMount() {
    const tabs = this.props.tabs || [];
    tabs.forEach((tab, tabIndex) => {
      const match = matchPath(this.props.location.pathname, {
        path: tab.path,
        exact: true,
      });

      if (match !== null) {
        this.setState({
          index: tabIndex,
        });
      }
    });
  }

  toggleConfigMenu() {
    if (this.state.configExpanded) {
      // When closing the config menu
      this.props.saveUserConfig();
    }

    this.setState({
      configExpanded: !this.state.configExpanded,
    });
  }

  handleTabChange = (index) => {
    this.setState({ index });
  };

  renderConfig = () => {
    const configExpanded = this.state.configExpanded;
    if (!this.props.showConfig) {
      return <div />;
    }

    return (
      <div
        className={styles.configMenu}
        onClick={() => this.toggleConfigMenu()}
        onKeyPress={() => this.toggleConfigMenu()}
        role="button"
        tabIndex="0"
      >
        <div className={styles.configButtonText}>
          {strings.generalStrings.settings}
        </div>
        <FontIcon
          className={
            configExpanded ? styles.configMenuIcon : styles.configMenuIconInvert
          }
          value="arrow_drop_down"
        />
      </div>
    );
  };

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.headerMenu}>
          <div className={styles.mainMenu}>
            <Tabs
              index={this.state.index}
              onChange={this.handleTabChange}
              className={styles.menuTabWrapper}
              fixed
            >
              {this.props.tabs.map((tab, index) => (
                <Tab
                  key={tab.label}
                  label={tab.label}
                  ripple={false}
                  onClick={() => {
                    // Refresh if we press the tab that we are curently on
                    if (this.props.history.location.pathname === tab.path) {
                      this.props.history.go(0);
                    } else {
                      this.props.history.push(tab.path);
                    }
                  }}
                  className={[
                    styles.menuTab,
                    this.state.index === index ? styles.menuTabActive : "",
                  ].join(" ")}
                />
              ))}
            </Tabs>
            {this.props.processTab.map((tab) => (
              <div
                key={tab.label}
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  className={styles.menuTab}
                  onClick={() => this.setState({ [tab.property]: true })}
                >
                  {tab.label}
                </div>
                <Menu
                  ripple={false}
                  position="topLeft"
                  className={styles.menuStyle}
                  active={this.state[tab.property]}
                  onHide={() => this.setState({ [tab.property]: false })}
                >
                  {tab.children.map((childrenTab) => (
                    <MenuItem
                      key={childrenTab.label}
                      caption={childrenTab.label}
                      onClick={() => window.open(childrenTab.path, "_blank")}
                    />
                  ))}
                </Menu>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
// {this.renderConfig()}
/*
        <ConfigContainer
          expanded={this.state.configExpanded && this.props.showConfig}
          value={this.props.user && this.props.user.config}
          onChange={( ( k, v ) => {
            this.props.setUserConfig( {
              ...this.props.user.config,
              [ k ]: v,
            } )
          } ).bind( this )}
        />
*/

const mapStateToProps = (store) => {
  return {
    user: store.user,
  };
};

export default connect(mapStateToProps, { setUserConfig, saveUserConfig })(
  withRouter(TopMenu)
);



// WEBPACK FOOTER //
// ./src/views/App/TopMenu/index.jsx